import React from "react";
import MarketplaceSellerIndex from "../components/marketplaceSeller/index.js";
import Footer from "../components/commonComponents/footer";
import Navbar from '../components/commonComponents/Navbar/Navbar';
import { useSelector } from "react-redux";
import PageLoader from "../common/pageLoader";

export default function MarketplaceSeller() {

    const { pageLoader } = useSelector(state => state.commonReducer);

    return (
        <div className={`${pageLoader && "body-overflow-hide"}`}>
            {/* <TopNavbar /> */}
            {pageLoader &&
                <PageLoader />
            }
            <Navbar />
            <MarketplaceSellerIndex />
            <Footer />
        </div>
    )
}